module.exports = __webpack_public_path__ + "static/media/mail_blue_icon.626d9ecd.svg";